import LockIcon from '@mui/icons-material/Lock';
import CardAction from '../../../../../../components/card/CardAction';
import './ViewMtssPlanAction.scss';
import { getSubjectId } from '../../../../../../utils/LessonsMapping';
import { findMtssLesson, useGetAllLessonsFromProfile } from '../../StudentLessonsHooks';

/**
 * Lock Lesson Action Container
 */
export default function ViewMtssPlanAction({ className, label, userProfile, lesson } = {
  className: '',
  label: '',
  // updateLessonFunction: () => {},
}) {
  const { ssoBaseUrl, eduIdentifier } = userProfile;
  const subjectId = getSubjectId(lesson);
  const allLessonsFromProfile = useGetAllLessonsFromProfile();
  const mttsLesson = findMtssLesson(lesson, allLessonsFromProfile);
  const { mtss } = mttsLesson;

  return (
    <CardAction
      icon={<LockIcon aria-hidden='false' />}
      label={label}
      actionHandler={() => {
        window.open(`${ssoBaseUrl}/core/students/${eduIdentifier}/vizzlemtss/${mtss}/${subjectId}`, '_blank');
      }}
      className={`view-mtss-plan-action ${className} ${label ? 'with-label' : ''}`}
      tabIndex={0}
      aria-hidden='false'
    />
  );
}
